import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import { useLanguage } from "context/LanguageContext";

// Bottom bar of a settings tab: change state on the left, actions and "Save" on the right; stays visible while scrolling.
function SaveBar({ dirty, saving, onSave, disabled, extraActions }) {
  const { t } = useLanguage();
  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 2,
        mt: 1,
        mx: { xs: -2, md: -3 },
        px: { xs: 2, md: 3 },
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1,
        bgcolor: "background.paper",
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography
        variant="body2"
        color={dirty ? "warning.main" : "text.secondary"}
        sx={{ display: { xs: "none", sm: "block" } }}
      >
        {dirty ? t("stUnsavedChanges") : t("stNoChanges")}
      </Typography>
      <Box display="flex" gap={1} flexWrap="wrap" ml="auto">
        {extraActions}
        <MDButton
          variant="contained"
          color="info"
          onClick={onSave}
          disabled={disabled || saving || !dirty}
        >
          {saving ? <CircularProgress size={18} color="inherit" /> : t("stSave")}
        </MDButton>
      </Box>
    </Box>
  );
}

SaveBar.propTypes = {
  dirty: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  extraActions: PropTypes.node,
};

SaveBar.defaultProps = {
  disabled: false,
  extraActions: null,
};

export default SaveBar;
